import { render, staticRenderFns } from "./assign-employer.vue?vue&type=template&id=4e97c46e"
import script from "./assign-employer.vue?vue&type=script&lang=js"
export * from "./assign-employer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports